<div class="form-wrapper">
  <div class="form-card" [@fadeSlide]>

    <app-user-login (conf)="conf" (fin)="cerrarModal($event)" *ngIf="is_login" class="form-content"></app-user-login>
    <app-user-registro (conf)="conf" (fin)="cerrarModal($event)" *ngIf="!is_login" class="form-content">
    </app-user-registro>
    <a class="toggle-link" href="javascript:void(0)" (click)="toggleForm()">
      {{ is_login ? '¿No tenés cuenta? Registrate' : '¿Ya tenés cuenta? Iniciá sesión' }}
    </a>
  </div>
</div>